var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M11.0099629,16 L52.9900371,16 C54.6497363,16 56,17.3517601 56,19.0132986 C56,20.674837 54.6497363,22.0266457 52.9900371,22.0266457 L11.0099629,22.0266457 C9.35026372,22.0359844 8,20.6842243 8,19.0132986 C8,17.3517601 9.35026372,16 11.0099629,16 L11.0099629,16 Z M18.6051963,30.991395 L45.3948037,30.991395 C47.0545028,30.991395 48.4047666,32.3431551 48.4047666,34.0046936 C48.4047666,35.6662321 47.0545028,37.0179922 45.3948037,37.0179922 L18.6051963,37.0179922 C16.9454972,37.0179922 15.5952334,35.6662321 15.5952334,34.0046936 C15.5952334,32.3431551 16.9454972,30.991395 18.6051963,30.991395 Z M26.2004298,45.9734029 L37.7995702,45.9734029 C39.4592694,45.9734029 40.8095331,47.325163 40.8095331,48.9867014 C40.8095331,50.6482399 39.4592694,52 37.7995702,52 L26.2004298,52 C24.5407306,52 23.1904669,50.6482399 23.1904669,48.9867014 C23.1904669,47.325163 24.5407306,45.9734029 26.2004298,45.9734029 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.322ad119c6d64a8d0c348433b12a6ddf.svg";
export { ForwardRef as ReactComponent };